import React from "react";
import { useIntl } from "react-intl";
import { classNames } from "@ct-react/core";
import { Button } from "../common/minimals";
import { agencyTranslations, bookingTranslations } from "../../i18n/sharable-defs";
import "./seasonal-box.scss";

type SeasonalBoxProps = {
  onAction?: () => void;
}

const SeasonalBox = ({ onAction = () => void 0 }: SeasonalBoxProps) => {

  const intl  = useIntl();
  const wrapperClasses = classNames("rla-book-seasonal");

  return (
    <div className={wrapperClasses}>
      <Button className="large bolder"
              type="button"
              onClick={() => onAction()}>{intl.formatMessage(agencyTranslations.contact)}</Button>
      <span className="textual-ondemand">
        {intl.formatMessage(bookingTranslations.onDemandHelper)}
      </span>
    </div>);

};

export default SeasonalBox;
